import { z } from "zod";
import { RevolutConnectionReturnUrlSchema } from "./integration.entity.ts";
import { PaymentModeSchema } from "./order.entity.ts";
import { RevolutOAuthUrlSchema } from "./platform.entity.ts";
import { Id } from "./workspace.entity.ts";

// The server binds the return URL to an organization-owned origin and route.
// HTTP is accepted only for loopback development; production still validates its
// own Hosting origins. No provider credentials or client-selected scope enter.
export const BeginRevolutConnectionInput = z
	.object({
		orgId: Id,
		env: PaymentModeSchema,
		returnUrl: RevolutConnectionReturnUrlSchema,
		currency: z.string().min(1).nullish(),
		confirmationCode: z
			.string()
			.regex(/^\d{6}$/)
			.nullish(),
	})
	.strict();
export type BeginRevolutConnectionInput = z.infer<
	typeof BeginRevolutConnectionInput
>;

export const BeginRevolutConnectionOutput = z
	.object({
		authorizationUrl: RevolutOAuthUrlSchema,
	})
	.strict();
export type BeginRevolutConnectionOutput = z.infer<
	typeof BeginRevolutConnectionOutput
>;
